import React from 'react'
import './footer.css'

export default function Footer() {
 
    return (
        <div className="footer">
            <p > &copy; Copyright 2021 <strong><span>Thao Truong</span></strong> | All
            Rights Reserved</p>
        </div >
    )
}
